import React from "react";
import { Grid, Typography } from "@material-ui/core";

const VisaoLogo = (props) => {
    const relatorio = props.relatorio;
    return (
        <Grid
            container
            direction="row"
            justifyContent="space-between"
            className="zoomPrinter"
        >
            <Typography variant="h5">
                <b>
                    {relatorio && relatorio.nome_relatorio
                        ? relatorio.nome_relatorio
                        : "Carregando..."}
                </b>
            </Typography>
            {relatorio &&
            relatorio.parametros_visao &&
            relatorio.parametros_visao.logo_url ? (
                <img
                    src={relatorio.parametros_visao.logo_url}
                    loading="lazy"
                    style={{ width: "5rem" }}
                />
            ) : (
                false
            )}
        </Grid>
    );
};

export default VisaoLogo;
